/** Evento disparado cuando Gestión Derivación asigna un pedido al médico. */
export const PEDIDO_DERIVADO_AL_MEDICO_EVENT = 'pulse:pedido-derivado-al-medico';

const STORAGE_KEY = 'pulse:pending-pedidos-derivados-medico';
const CHANNEL_NAME = 'pulse:pedidos-medico-sync';
const MAX_QUEUE = 30;

function readQueue() {
  if (typeof window === 'undefined') return [];
  try {
    const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch (_) {
    return [];
  }
}

function writeQueue(items) {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(-MAX_QUEUE)));
  } catch (_) { /* ignore quota */ }
}

function enqueuePedidoDerivado(detail) {
  const queue = readQueue();
  const id = detail?.pedido?.id;
  const filtered = id != null
    ? queue.filter((item) => String(item?.pedido?.id) !== String(id))
    : queue;
  filtered.push({ ...detail, enqueuedAt: Date.now() });
  writeQueue(filtered);
}

/**
 * Persiste y notifica derivación (misma pestaña, otras pestañas y navegación posterior).
 * @param {{ pedido: object, medico?: object }} detail
 */
export function dispatchPedidoDerivadoAlMedico(detail) {
  if (typeof window === 'undefined' || !detail?.pedido) return;

  const normalized = {
    ...detail,
    pedido: { ...detail.pedido, estado: 'pendiente_aprobacion_medica' },
  };
  enqueuePedidoDerivado(normalized);

  window.dispatchEvent(new CustomEvent(PEDIDO_DERIVADO_AL_MEDICO_EVENT, { detail: normalized }));

  try {
    const bc = new BroadcastChannel(CHANNEL_NAME);
    bc.postMessage({ type: 'derivado', detail: normalized });
    bc.close();
  } catch (_) { /* BroadcastChannel no disponible */ }
}

/**
 * Devuelve derivaciones pendientes de ingestar y limpia la cola.
 * @returns {Array<{ pedido: object, medico?: object }>}
 */
export function drainPendingPedidosDerivadosMedico() {
  const queue = readQueue();
  writeQueue([]);
  return queue.map(({ pedido, medico }) => ({ pedido, medico }));
}

/**
 * @param {(detail: { pedido: object, medico?: object }) => void} onDerivado
 * @returns {() => void} cleanup
 */
export function subscribePedidosMedicoSync(onDerivado) {
  if (typeof window === 'undefined') return () => {};

  const onEvent = (ev) => {
    if (ev?.detail?.pedido) onDerivado(ev.detail);
  };

  window.addEventListener(PEDIDO_DERIVADO_AL_MEDICO_EVENT, onEvent);

  let bc = null;
  try {
    bc = new BroadcastChannel(CHANNEL_NAME);
    bc.onmessage = (msg) => {
      const { type, detail } = msg?.data || {};
      if (type === 'derivado' && detail?.pedido) onDerivado(detail);
    };
  } catch (_) { /* ignore */ }

  return () => {
    window.removeEventListener(PEDIDO_DERIVADO_AL_MEDICO_EVENT, onEvent);
    try {
      bc?.close();
    } catch (_) { /* ignore */ }
  };
}
